module.exports = __webpack_public_path__ + "img/icon_master_blue.f2b30dbc.svg";